import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Copy } from "lucide-react";
import { api, SITE } from "@/lib/api";

export const Referrals = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/me/referrals").then((x) => setR(x.data)); }, []);
  if (!r) return null;
  const link = `${SITE}/join?ref=${r.code}`;
  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copied"); };
  return (
    <div className="panel console-corners p-6" data-testid="referral-panel">
      <div className="label-mono mb-2 flex items-center gap-2 !text-[#FFB800]"><Gift className="h-3.5 w-3.5" />Invite artists, get Pro</div>
      <p className="text-sm text-slate-300">Share your code. When an artist you invite gets approved, you <strong>both</strong> get 1 week of Pro for free.</p>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <span className="led rounded-lg border border-[#FFB800]/40 px-4 py-2 text-2xl font-bold" data-testid="referral-code">{r.code}</span>
        <button className="btn-ghost !px-4 !py-2 text-xs" onClick={() => copy(r.code)} data-testid="referral-copy-code"><Copy className="h-3.5 w-3.5" />Code</button>
        <button className="btn-hot !px-4 !py-2 text-xs" onClick={() => copy(link)} data-testid="referral-copy-link"><Copy className="h-3.5 w-3.5" />Invite link</button>
      </div>
      {r.invited.length > 0 && (
        <div className="mt-5" data-testid="referral-list">
          {r.invited.map((x, i) => (
            <div key={i} className="flex justify-between border-b border-white/5 py-2 text-sm">
              <span>{x.stage_name}</span>
              <span className={`font-mono text-xs uppercase ${x.rewarded ? "text-[#00F5D4]" : "text-slate-500"}`}>{x.rewarded ? "Pro week earned" : x.status === "approved" ? "approved" : "waiting approval"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
